import { render, staticRenderFns } from "./BlogContainer.vue?vue&type=template&id=50e9e37c&"
import script from "./BlogContainer.vue?vue&type=script&lang=js&"
export * from "./BlogContainer.vue?vue&type=script&lang=js&"
import style0 from "./BlogContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports